import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { RouterLink } from "@angular/router";
import { TranslateModule, TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'cookie-policy-page-component',
  templateUrl: './cookie-policy-page.component.html',
  styleUrl: './cookie-policy-page.component.scss',
  imports: [
    CommonModule,
    TranslateModule
  ]
})
export class CookiePolicyPage {
  public lang: string | null = null;
  constructor(private translateService: TranslateService) {
    this.lang = this.translateService.currentLang;
  }
}